import React from 'react';

import {getStateCode} from '../lib/geoUtils'

export default function CountyImage(props) {
    let countyImgUrl = '/images/county-thumbnails/'
        + getStateCode(props.state) + '-'
        + props.county.replace(/ /g, '-').replace(/\./, '')
        + '-' + props.pixelSize + '.png'

    return (
        <img src={countyImgUrl} width={props.width || props.pixelSize} alt='' className="county-image" />
    )
}
